<mat-spinner [diameter]="20"></mat-spinner>
<p class="mat-caption" i18n>Loading...</p>